import { render, staticRenderFns } from "./BrushstrokeHeading.vue?vue&type=template&id=215fdfc3&scoped=true&"
import script from "./BrushstrokeHeading.vue?vue&type=script&lang=js&"
export * from "./BrushstrokeHeading.vue?vue&type=script&lang=js&"
import style0 from "./BrushstrokeHeading.vue?vue&type=style&index=0&id=215fdfc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215fdfc3",
  null
  
)

export default component.exports